import type { LogParams } from '@application/api';
import type { CountryCode } from '@gql/graphql';
import type { SelectOption, StepLineProps } from '@presentation/components';
import type { LocationDescriptor } from 'history';
import type { ReactElement } from 'react';

export interface OnboardingStep {
  key: number; // 0 - 12
  component: ReactElement;
}

export interface ShowState {
  variant: string | undefined;
  selected: boolean | undefined;
}

export type ImageProps = {
  image: {
    image: string | undefined;
    name: string;
  };
};

export interface Step13DataType {
  id: number;
  title: string;
  data: string | string[];
  text?: string;
  step?: number;
  image?: string;
}

export type MtBreederOnboardingFormValues = {
  // Step 1
  spokenLanguages?: string[];
  city?: string;
  zip?: string;
  region?: string;
  country: CountryCode;

  // Step 2
  level?: string | null;
  agreementNumber?: string | null;

  // Step 3
  breedingName?: string;
  dogBreedsIds?: number[];
  dogsPedigree?: string | null;

  // Step 4
  websiteUrl?: string;
  facebookUrl?: string;

  // Step 5
  femaleBreedersCount?: number;
  motherRestBetweenLitters?: string;
  littersByFemale?: string;

  // Step 6
  medicalTestsPerformed?: string;
  dogsConsanguinity?: string;

  // Step 7
  veterinaryInfo?: string;
  veterinaryNumber?: string;

  // Step 10
  profileImage?: File | string;
  images?: File[] | string[] | undefined[];

  // Step 11
  hkFile?: File | string;
  permissionFiles?: File[] | string[];
  identityFiles?: File[] | string[];
  breedClubFiles?: File[] | string[];
  certificationFile?: File | string;

  translated?: Record<
    string,
    Partial<{
      id?: number;
      description?: string; // step 5
      puppiesLivingPlace?: string; // step 9
      dogsLivingPlace?: string; // step 9
      breederDogsSelection?: string; // step 10
      puppiesTraining?: string; // step 10
    }>
  >;
};

export interface MtBreederOnboardingPageData {
  steps: OnboardingStep[];
  currentStep: number;
  onNextClick: () => void;
  onStartClick: () => void;
  onFinishOnboardingClick: () => void;
  loading?: boolean;
  link?: LocationDescriptor;
  showCertificationFileField?: boolean;
  breedOptions: SelectOption<number>[];
  stepLineProps: Pick<StepLineProps, 'currentStep' | 'steps'>;
  onBackClick: () => void; // TODO: remove once we deploy to prod
  onEditClick: () => void;
  onCloseClick: () => void;
  agreementNumberWarning?: string;
  breederTypeWarning?: string;
  breedingNameLabel: string;
  agreementNumberIsRequired: boolean;
  hideAgreementNumberField: boolean;
  showGermanFileFields: boolean;
  log: (params: LogParams) => void;
}

export interface MtBreederOnboardingPageProps extends MtBreederOnboardingPageData {}
